import React from 'react'
import { useTheme } from '@/context/ThemeContext'
import DecisionToggle from './DecisionToggle'
import { ACTION_GROUPS, ACTION_LABELS } from '../types'
import type { ActionDecision, CrmActionKey } from '../types'

type Props = {
  actions: Record<CrmActionKey, ActionDecision>
  onChange: (key: CrmActionKey, value: ActionDecision) => void
  disabled?: boolean
}

const ActionsSection: React.FC<Props> = ({ actions, onChange, disabled }) => {
  const { currentTheme: t } = useTheme()

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 items-start">
      {ACTION_GROUPS.map((group) => (
        <div
          key={group.title}
          className="rounded-[14px] p-3.5 flex flex-col gap-3"
          style={{ backgroundColor: t.sectionBackground, border: `1px solid ${t.border}` }}
        >
          <h3 className="text-[11px] font-semibold uppercase tracking-[0.06em]" style={{ color: t.mutedText }}>
            {group.title}
          </h3>
          <div className="flex flex-col gap-3">
            {group.keys.map((key, i) => (
              <div
                key={key}
                className="flex items-center justify-between gap-3 pt-3"
                style={{ borderTop: i === 0 ? 'none' : `1px solid ${t.borderSecondary}`, ...(i === 0 ? { paddingTop: 0 } : {}) }}
              >
                <span className="text-[12.5px] leading-snug" style={{ color: t.text }}>{ACTION_LABELS[key]}</span>
                <DecisionToggle
                  value={actions[key] ?? 'approval'}
                  onChange={(value) => onChange(key, value)}
                  {...(disabled ? { disabled } : {})}
                />
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  )
}

export default React.memo(ActionsSection)
